import Vue from 'vue'
import Router from 'vue-router'
import base from '@/utils/base'
import getTranslation from '@/locale/getTranslation'

//路由
import news from './modules/news' //新闻中心-移动

//路由
Vue.use(Router)

let routes = [
  ...news,
  {
    path: '/',
    redirect: '/home'
  },
  // {
  //   path: '/news',
  //   name: 'web_news',
  //   component: () => import('@/views/news'),
  //   meta: {
  //     title: getTranslation('新闻中心')
  //   },
  //   beforeEnter: async (to, from, next) => {
  //     if (base.isMobile()) {
  //       next({
  //         name: 'mobile_news'
  //       })
  //     } else {
  //       next()
  //     }
  //   }
  // },
  {
    path: '/error',
    component: () => import('@/views/Error'),
    hidden: true
  },
  {
    path: '/home',
    name: 'pc_home',
    meta: {
      title: getTranslation('新闻中心首页')
      // keepAlive:true
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_news'
        })
      } else {
        next()
      }
    },
    component: () => import('@/views/news/home')
  },
  // {
  //   path: '/videoDetails',
  //   name: 'web_video_detail',
  //   beforeEnter: async (to, from, next) => {
  //     if (base.isMobile()) {
  //       next({
  //         name: 'mobile_video_detail'
  //       })
  //     } else {
  //       next()
  //     }
  //   },
  //   component: () => import('@/views/video_details')
  // },
  // {
  //   path: '/video',
  //   name: 'web_video',
  //   beforeEnter: async (to, from, next) => {
  //     if (base.isMobile()) {
  //       next({
  //         name: 'mobile_video'
  //       })
  //     } else {
  //       next()
  //     }
  //   },
  //   component: () => import('@/views/video')
  // },
  // {
  //   path: '/picture',
  //   name: 'web_picture',
  //   beforeEnter: async (to, from, next) => {
  //     if (base.isMobile()) {
  //       next({
  //         name: 'mobile_picture'
  //       })
  //     } else {
  //       next()
  //     }
  //   },
  //   component: () => import('@/views/picture')
  // },
  {
    path: '/consult',
    name: 'pc_consult',
    meta: {
      title: getTranslation('新闻中心资讯详情')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_detail',
          query: to.query
        })
      } else {
        next()
      }
    },
    component: () => import('@/views/news/consult')
  },
  {
    path: '/dataCenter',
    name: 'pc_data',
    meta: {
      title: getTranslation('新闻中心资料')
    },
    component: () => import('@/views/news/dataCenter'),
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_list',
          query: to.query
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/search',
    name: 'pc_search',
    meta: {
      title: getTranslation('搜索结果页'),
      keepAlive: true
    },
    component: () => import('@/views/news/search')
  },
  {
    path: '/cover',
    name: 'pc_cover',
    meta: {
      title: getTranslation('新闻中心通知')
    },
    component: () => import('@/views/news/cover'),
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_notice',
          query: to.query
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/notice',
    name: 'web_notice',
    meta: {
      title: getTranslation('新闻中心资讯')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_trends',
          query: to.query
        })
      } else {
        next()
      }
    },
    component: () => import('@/views/news/notice')
  },
  //错误路由地址处理跳转
  {
    path: '*',
    redirect: '/error'
  }
]

const router = new Router({
  mode: 'history',
  routes: routes
})

export default router
